<template><svg v-bind="$attrs"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 9 9">
  <circle cx="5" cy="4" r="4.5" fill="#C9311A" stroke="#fff"/>
</svg>
</template>